<template>
  <dir class="scrollable-container">
    <v-toolbar
      :color="themeColor"
      flat>
      <span class="title">設定</span>
    </v-toolbar>

    <app-card-container class="flex-grow overflow-y-auto">
      <app-card title="音訊">
        <v-layout row wrap>
          <v-flex xs6>
            <v-card-text>
              <label class="subheading">麥克風</label>
              <v-tooltip bottom>
                <div slot="activator" class="device-label mt-3">{{audioinput.label}}</div>
                <span>{{audioinput.label}}</span>
              </v-tooltip>
            </v-card-text>
          </v-flex>

          <v-flex xs6>
            <v-card-text>
              <label class="subheading">喇叭</label>
              <v-tooltip bottom>
                <div slot="activator" class="device-label mt-3">{{audiooutput.label}}</div>
                <span>{{audiooutput.label}}</span>
              </v-tooltip>
            </v-card-text>
          </v-flex>

          <v-flex xs12>
            <v-card-text>
              <label class="subheading">麥克風測試</label>
              <mic-volume-meter class="mt-3" :deviceId="audioinput.deviceId"/>
            </v-card-text>
          </v-flex>
        </v-layout>
      </app-card>

      <app-card title="視訊">
        <v-layout row wrap>
          <v-flex xs6>
            <v-card-text>
              <label class="subheading">相機</label>
              <v-tooltip bottom>
                <div slot="activator" class="device-label mt-3">{{videoinput.label}}</div>
                <span>{{videoinput.label}}</span>
              </v-tooltip>
            </v-card-text>
          </v-flex>

          <v-flex xs6>
            <v-card-text>
              <label class="subheading">預覽</label>
              <web-cam-preview class="mt-3" :deviceId="videoinput.deviceId" />
            </v-card-text>
          </v-flex>

        </v-layout>
      </app-card>
    </app-card-container>
  </dir>
</template>

<script>
import MicVolumeMeter from './MicVolumeMeter';
import WebCamPreview from './WebCamPreview';

export default {
  name: 'Settings',
  components: {
    'mic-volume-meter': MicVolumeMeter,
    'web-cam-preview': WebCamPreview
  },

  data() {
    return {
      audioinput: {},
      videoinput: {},
      audiooutput: {},
      audioinputDevices: [],
      videoinputDevices: [],
      audiooutputDevices: []
    };
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
  },

  methods: {
    async init() {
      let devices = await this.getDevices();

      devices.forEach(d => {
        d.text = d.label.split('-')[0].trim();
        if (d.kind === 'audioinput') {
          this.audioinputDevices.push(d);
        } else if (d.kind === 'videoinput') {
          this.videoinputDevices.push(d);
        } else if (d.kind === 'audiooutput') {
          this.audiooutputDevices.push(d);
        }
      });

      this.audioinput = this.getDefaultDevice(this.audioinputDevices);
      this.videoinput = this.getDefaultDevice(this.videoinputDevices);
      this.audiooutput = this.getDefaultDevice(this.audiooutputDevices);
    },

    getDevices() {
      return navigator.mediaDevices.enumerateDevices();
    },

    getDefaultDevice(devices) {
      if (!devices.length) {
        return {};
      }
      if (devices.length === 1) {
        return devices[0];
      }
      return devices.find(d => d.deviceId === 'default') || {};
    },

    save() {},
    clear() {}
  }
};
</script>

<style lang="stylus" scoped>
.device-label {
  border: 2px solid rgba(0,0,0,0.7);
  border-radius: 5px;
  width: 100%;
  padding: 1rem;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
